import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import PlayIcon from "@material-ui/icons/PlayArrow";
import Button from "@material-ui/core/Button";
// import YouTube from "react-youtube";
import ReactPlayer from "react-player";
import ReactGA from "react-ga";

const styles = theme => ({
  paper: {
    textAlign: "center",
    position: "absolute",
    color: "#000",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block"
  },
  closeButton: {
    marginTop: "2em"
  }
});

function VideoOverlay(props) {
  const { classes, link } = props;
  // const videoId = new URL(link).searchParams.get("v");
  // const width = window.innerWidth - window.innerWidth / 5;
  // const height = width / 1.77;
  // const opts = {
  //   height,
  //   width,
  //   playerVars: {
  //     // https://developers.google.com/youtube/player_parameters
  //     autoplay: 1
  //   }
  // };
  return (
    <div className={classes.root}>
      {/* <YouTube videoId={videoId} opts={opts} /> */}
      <ReactPlayer width="90vw" height="51vw" url={link} controls playing />
    </div>
  );
}

VideoOverlay.propTypes = {
  classes: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired
};

class Media extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.showMedia = this.showMedia.bind(this);
  }

  Media() {
    const { classes, type, link, title } = this.props;
    let content = "";
    switch (type) {
      case "vimeo":
        content = <VideoOverlay {...this.props} />;
        break;
      case "youtube":
        content = <VideoOverlay {...this.props} />;
        break;
      case "image":
        content = <img className={classes.image} src={link} alt={title} />;
        break;
      default:
        break;
    }
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.open}
        onClose={this.handleClose}
      >
        <div className={classes.paper}>
          <h1>{title}</h1>
          {content}
          <Button
            color="primary"
            className={classes.closeButton}
            onClick={this.handleClose}
          >
            Sluiten
          </Button>
        </div>
      </Modal>
    );
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  showMedia() {
    const { type, link } = this.props;

    ReactGA.event({
      category: "Route",
      action: `Opened ${type} link`,
      label: link
    });
    if (type === "website") {
      window.open(link, "_blank", "noopener noreferrer");
    } else {
      this.setState({
        open: true
      });
    }
  }

  render() {
    const { classes } = this.props;
    const { open } = this.state;
    return (
      <div>
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.playButton}
          onClick={this.showMedia}
        >
          <PlayIcon />
        </Button>
        {open ? this.Media() : null}
      </div>
    );
  }
}

Media.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default withStyles(styles)(Media);



// WEBPACK FOOTER //
// ./src/NewRoute/atoms/Media.js